import CASING from 'constants/casing.const';
import ORDER from 'constants/order.const';
import getAnyOrVoid from 'utils/accessors/getAnyOrVoid.util';
import fromAnyToLowerCase from 'utils/converters/any/fromAnyToLowerCase.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import alwaysZero from 'utils/functions/nullary/alwaysZero.util';
import withOptions from 'utils/functions/withOptions.util';
import isMissing from 'utils/predicates/any/isMissing.util';
import isEnumVal from 'utils/predicates/enum/isEnumVal.util';

const DEFAULT_ORDER = ORDER.asc;
const DEFAULT_CASING = CASING.sensitive;

const fromAnyToUpper = (value) => fromAnyToString(value).toUpperCase();
const CONVERTOR = Object.freeze({
  [CASING.sensitive]: fromAnyToString,
  [CASING.lower]: fromAnyToLowerCase,
  [CASING.upper]: fromAnyToUpper,
  [CASING.ignore]: fromAnyToUpper,
});

const byText = withOptions(({ key, order, casing }) => {
  const isKeyMissing = isMissing(key);
  const path = fromAnyToTrimmed(key); // NOTE: Symbols not currently supported

  // if the key is not missing, it must be a valid path or else it doesn't make sense to compare
  if (!isKeyMissing && !path) return alwaysZero;

  const ord = isEnumVal(ORDER, order) ? order : DEFAULT_ORDER;
  const cas = isEnumVal(CASING, casing) ? casing : DEFAULT_CASING;
  const convert = CONVERTOR[cas] || fromAnyToString;

  // prepare the getter that will retrieve and transform the value for comparison
  const get = isKeyMissing ? (o) => convert(o) : (object) => convert(getAnyOrVoid(path, object));

  return (a, b) => {
    const textA = convert(get(a));
    const textB = convert(get(b));

    // eslint-disable-next-line no-nested-ternary
    const diff = textA < textB ? -1 : textB < textA ? 1 : 0;

    // prevents from getting -0 which will fail the test pointlessly since Object.is(-0,+0) returns false
    if (diff === 0) return 0;

    return ord === ORDER.asc ? diff : -1 * diff;
  };
});
// noinspection JSUnusedGlobalSymbols
export default byText;
